// extracted by css-extract-rspack-plugin
export default {"cls1":"TranslationModal-cls1_tF-","cls2":"TranslationModal-cls2_Tiu TranslationModal-cls1_tF-"};